module.exports = __webpack_public_path__ + "static/media/ScytheofVyse.5f5935d6.png";